<h1 class="page-title">Bibliaiskola</h1>

<h2>A bibliaiskolánkról</h2>

<p>
  Úgy gondoljuk, hogy a bibliaiskola nem az a hely, ahová csak azoknak kell menni, akik előbb-utóbb lelkipásztorok,
  tanítók szeretnének lenni, hanem minden egyes hívő számára nagyon hasznos, mert sokkal nagyobb mélységekbe, nagyobb
  részletességgel lehet belemenni, mint amire egy általános istentiszteleti keretben lehetőség van.
</p>

<p>
  Ezért mindenkinek csak ajánlani tudjuk, hogy amennyiben van rá lehetősége, járjon el bibliaiskolás órákra. Aki ezt a
  döntést meghozza, és meg is csinálja, garantáltan nem fogja megbánni!
</p>

<h2>KETA</h2>

<p>
  <!--img:KETA (Közép-Európai Teológiai Akadémia)-->
  Bibliaiskolánk a KETA (Közép-Európai Teológiai Akadémia) kihelyezett tagozataként működik, és készíti fel diákjait egy
  elkötelezett, másokat szolgáló életre.
</p>

<!--<h2>Aktuális órák</h2>-->



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/bibleschool/bibleschool.component.html